import { ReturnBlock } from "../../../ReturnBlock";

/**
 * "Less than" block.
 */
export class LTBlock extends ReturnBlock {
    leftSide;
    rightSide;

    /**
     * Constructor
     * @param inputs the inputs of comparison (inputs[0] is left; inputs[1] is right)
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id);
        this.leftSide = inputs[0];
        this.rightSide = inputs[1];
    }

    /**
     * Compares left and right side, returns true if "leftSide < rightSide"
     * @param varEnv the variable envornment
     */
    evalBlock(varEnv: Map<string, any>) {
        let ls = this.leftSide.evalBlock(varEnv);
        let rs = this.rightSide.evalBlock(varEnv);

        return ls < rs;
    }
}